"use strict";
import {pageInfo} from "./page_info.js";

$(function() {
    if(pageInfo.needs_reload === true) {
        const event = {type: 'reload-required'};
        $(document).trigger('broadcast', {event: event});
    }
});
